<template>
  <div class="block-hero basic-block">
    <img class="hero-img" src="/static/img/lp/campaign/lineCampaign202110/hero_20220316.png">
  </div>
</template>

<script>

export default {
  name: 'BlockHero',
}</script>

<style scoped lang="scss">
.block-hero {
  .hero-img {
    width: 100%;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/lp/campaign/LineCampaign202110/blocks/BlockHero.vue